import { SupportedGames } from "@/types/game";

const LAST_GAME_KEY = "tcgfan_last_game";
const PREFERENCE_ASKED_KEY = "tcgfan_preference_asked";

export function getLastVisitedGame(): SupportedGames | null {
  if (typeof window === "undefined") return null;

  try {
    const lastGame = localStorage.getItem(LAST_GAME_KEY);
    return lastGame as SupportedGames | null;
  } catch (error) {
    console.warn("Failed to get last visited game from localStorage:", error);
    return null;
  }
}

export function setLastVisitedGame(game: SupportedGames): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(LAST_GAME_KEY, game);
  } catch (error) {
    console.warn("Failed to set last visited game in localStorage:", error);
  }
}

export function clearLastVisitedGame(): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(LAST_GAME_KEY);
  } catch (error) {
    console.warn("Failed to clear last visited game from localStorage:", error);
  }
}

export function hasAskedForPreference(): boolean {
  if (typeof window === "undefined") return false;

  try {
    return localStorage.getItem(PREFERENCE_ASKED_KEY) === "true";
  } catch (error) {
    console.warn("Failed to check preference asked from localStorage:", error);
    return false;
  }
}

export function setPreferenceAsked(): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(PREFERENCE_ASKED_KEY, "true");
  } catch (error) {
    console.warn("Failed to set preference asked in localStorage:", error);
  }
}
